module.exports = __webpack_public_path__ + "img/ot-qiavax_usdc.2b3e1ace.png";